module.exports = __webpack_public_path__ + "assets/img/step8-1-sz.437aa66a.png";